import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useSetAtom } from 'jotai';
import useAPI from '../api';
import { openSnackbarAdviseAtom } from '../Atoms';

const CallToActionPage = function CallToActionPage() {
  const API = useAPI();
  const intl = useIntl();
  const navigate = useNavigate();
  const { ctaId, activityId } = useParams();
  const setOpenSnackbar = useSetAtom(openSnackbarAdviseAtom);

  useEffect(() => {
    API.registerCallToActionInteraction(
      ctaId,
      activityId,
      {},
      (responseText) => {
        navigate('/responseRegistered', {
          replace: true,
          state: { responseText },
        });
      },
      () => {
        setOpenSnackbar({
          severity: 'error',
          message: intl.messages.IMPOSSIBLE_TO_REGISTER,
        });
      }
    );
  }, [ctaId, activityId]);

  return <div />;
};

export default CallToActionPage;
